import React, { Component, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./scss/style.scss";
import "./scss/_post_previews.scss";
import Invitation from "./views/profile/Invitation";
import ForgotPassword from "./views/pages/forgot-password/ForgotPassword";
import "./language/langageTranslator";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const LoginGivenEmail = React.lazy(() => import("./views/pages/login/LoginGivenEmail"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login" element={<Login />} />
            <Route exact path="/login-given-email" name="Login" element={<LoginGivenEmail />} />
            <Route exact path="/register" name="Register" element={<Register />} />
            <Route exact path="/forgot-password" name="Reinitialize Password" element={<ForgotPassword />} />
            <Route exact path="/invitation" name="Invitation Page" element={<Invitation />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            {/*<Route path="/apps/email/*" name="Email App" element={<EmailApp />} />*/}
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
